import { extractQuoteFromQuery } from '#pplx/frontend/components/search/markdown/utils/quoteUtils.js';
/**
 * Recalls only the question text when Up selects a quoted follow-up.
 * A follow-up that was only a quote yields an empty string and is skipped.
 */
export function parseRecalledPrompt(queryStr) {
    return (extractQuoteFromQuery(queryStr).actualQuery ?? '').trim();
}
//# sourceMappingURL=recalledPrompt.js.map